<template>
  <div>
    <li @click="onOpen">
      <p>アカウントを削除</p>
      <img class="chev" src="@/assets/chevron.svg" />
    </li>
    <div v-if="isDialogOpen" class="background" @click="onClose"></div>
    <div v-if="isDialogOpen" class="dialog">
      <p>
        アカウントを削除するとすべてのデータと設定が永久に削除され、復元は不可能です。またこの操作を取り消すことはできません。
      </p>
      <p>
        削除を続行する場合パスワードを入力後、「削除する」ボタンを押してください。
      </p>
      <p class="error-message">{{ errorMessage }}</p>
      <label>パスワード</label>
      <input
        class="inputpasswordArea"
        v-model="password"
        placeholder="パスワードを入力"
        type="password"
      />
      <div class="buttons-area">
        <div class="button confirm" @click="clickSubmitDelete">削除する</div>
        <div class="button close" @click="onClose">キャンセル</div>
      </div>
    </div>
  </div>
</template>

<script>
import Firebase from "./../../firebase";

export default {
  name: "delete-user-dialog",
  components: {},
  props: {},
  computed: {},
  data() {
    return {
      password: "",
      isDialogOpen: false,
      errorMessage: "",
    };
  },
  methods: {
    async clickSubmitDelete() {
      await Firebase.deleteAccount(this.password)
        .then(() => {
          location.reload();
        })
        .catch((result) => {
          if (result.code === "auth/wrong-password") {
            this.errorMessage = "パスワードが違います";
          } else {
            this.errorMessage = "エラーが発生しました";
          }
        });
    },
    onOpen() {
      this.isDialogOpen = true;
    },
    onClose() {
      this.isDialogOpen = false;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./../../unified.scss";

li {
  margin: 0;
  display: flex;
  padding: 1rem 0.5rem;
  font-size: 0.8rem;
  border-top: 1px #e7e7e7 solid;
  position: relative;
  align-items: center;
  p {
    margin: 0;
    width: calc(100% - 1.5rem);
  }
  .chev {
    transform: rotate(-90deg);
    height: 0.5rem;
  }
}
.background {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1000;
}
.dialog {
  position: fixed;
  flex-direction: column;
  left: 50%;
  top: 50%;
  transform: translateX(-50%) translateY(-55%);
  background-color: white;
  z-index: 1001;
  width: 80vw;
  overflow-y: scroll;
  padding: 1rem;
  border-radius: 12px;

  p {
    margin: 0.5rem 0;
  }

  .buttons-area {
    margin-top: 1rem;
    display: flex;
    gap: 2rem;
  }

  .button {
    margin: 1rem 0;
    text-align: center;
    border-radius: 4px;
    background-color: #5cd5d6;
    padding: 0.75rem 0;
    color: white;
    font-size: 0.9rem;
    font-size: 0.8rem;
    padding: 0.5rem 0;
    width: 100%;
    &.confirm {
      background-color: #ff7c86;
    }
  }
}

.error-message {
  color: #ff7c86;
}

label {
  display: block;
  margin-bottom: 4px;
}
input {
  line-height: 2;
  width: calc(100% - 8px);
  border: none;
  border-bottom: 1px solid #373737;
}
</style>



// WEBPACK FOOTER //
// src/components/MyPage/DeleteUserDialog.vue